module.exports = __webpack_public_path__ + "static/Hero_Logos_Mobile-e5287c9d2c635b2b74fa1ade4ec98e3b.jpg";